<template>
  <layout :title="pageTitle">
    <QuestionDescriptions v-model="questionSetDescriptionsForm" />

    <div class="columns">
      <div class="column">
        <button @click="submit" type="submit" class="button is-primary">
          Next
        </button>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '../Layout';
import QuestionDescriptions from '../../../Components/Management/QuestionDescriptions';

export default {
  components: {
    QuestionDescriptions,
    Layout,
  },
  props: {
    questionSet: { type: Object },
    projectID: { type: String },
  },
  data() {
    return {
      pageTitle: 'Setup Scores for Question Set: ' + this.questionSet.name,
      questionSetDescriptionsForm: this.questionSet.question_descriptions,
    };
  },
  methods: {
    submit() {
      this.$inertia.post(
        route(
          'question-sets.setup.questionDescriptions',
          this.questionSet.unique_id
        ),
        {
          questionSetDescriptions: this.questionSetDescriptionsForm,
          projectID: this.projectID,
        }
      );
    },
  },
};
</script>
